import { DenovoIcon, Typography } from "@repo/design-system";

export function UpdatingIndicator() {
  return (
    <div className="flex items-center gap-2">
      <DenovoIcon
        icon="progress"
        width={16}
        height={16}
        className="animate-spin text-contentBrand"
      />
      <Typography
        variant="paragraph-m-regular"
        className="text-contentSecondary">
        Updating…
      </Typography>
    </div>
  );
}
